export default __webpack_public_path__ + "static/media/contact_icon.d5feb13d.svg";